import type { FC } from 'react';

import type { FormFieldProps } from '@zen/Components/Form/FormField';
import { shipmentTypeOptions } from '@zen/LegacyBooking/helpers';

import FormSelect from '../FormSelect';

interface Props extends FormFieldProps {}

const FormShipmentTypeSelect: FC<Props> = (props) => {
  return <FormSelect {...props} options={shipmentTypeOptions} placeholder="Select shipment type" />;
};

export default FormShipmentTypeSelect;
